import { render } from "./ChildTabComponent.vue?vue&type=template&id=51fe8d3b&scoped=true"
import script from "./ChildTabComponent.vue?vue&type=script&lang=js"
export * from "./ChildTabComponent.vue?vue&type=script&lang=js"

import "./ChildTabComponent.vue?vue&type=style&index=0&id=51fe8d3b&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51fe8d3b"]])

export default __exports__